import React from 'react'
import PropTypes from 'prop-types'
import Actions from 'scripts/components/article/Actions'
const Reactions = (props) => {
  return (
    <div className="article-reactions center-align section">
      <div className="reactions-title">{props.title}</div>
      <Actions {...props.settings} />
    </div>
  )
}
Reactions.propTypes = {
  title: PropTypes.string.isRequired,
  settings: PropTypes.shape({
    id: PropTypes.string.isRequired,
    reactions: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        count: PropTypes.number,
        viewerHasReacted: PropTypes.bool
      })
    )
  }).isRequired
}

export default Reactions



// WEBPACK FOOTER //
// ./assets/js/components/article/Reactions.jsx